import { Injectable, Injector } from '@angular/core';
import { ConnectableObservable, Observable, of, ReplaySubject } from 'rxjs';
import { Router } from '@angular/router';
import { LoadingService } from '../../common/layout/loading.service';
import { NotificationService } from '../../common/layout/notification.service';
import { map } from 'rxjs/operators';
import { SecurityService } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    private userIsLoginSubject: ReplaySubject<boolean> = new ReplaySubject(0);
    private _user: any = null;

    constructor(
        private injector: Injector,
        private loadingService: LoadingService,
        private notificationService: NotificationService,
        private securityApi: SecurityService
    ) {
    }

    get userIsLogin$(): Observable<boolean> {
        return this.userIsLoginSubject.asObservable();
    }

    public get router(): Router {
        return this.injector.get(Router);
    }

    public userHasLogged() {
        this.userIsLoginSubject.next(true);
    }

    get user(): any {
        return this._user;
    }

    set user(value: any) {
        this._user = value;
    }

    public login(user: { username?: string; password?: string; goldfingerToken?: string }): ConnectableObservable<any> {
        return this.securityApi.goldfingerAuthorizeHandler(user)
            .pipe(
                map(() => {
                    this.userHasLogged();
                })
            ) as ConnectableObservable<any>;
    }

    public logout(): Promise<any> {
        this.loadingService.start();
        return new Promise<any>((resolve, reject) => {
            this.securityApi.logoutHandler().subscribe(
                () => {

                    this.user = null;

                    this.loadingService.stop();
                    resolve();
                },
                () => {
                    this.loadingService.stop();
                    this.notificationService.error('Akcja wylogowania nie powiodła się');
                     reject();
                }
            );
        });
    }

    public downloadCurrentUser() {
        return this.securityApi.currentUserQuery()
            .pipe(
                map(user => {
                    this.userHasLogged();
                    this.user = user;
                })
            ) as ConnectableObservable<any>;
    }
}
